import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import analyticsMiddleware from '../helpers/analyticsMiddleware';
import useStepsReducer from '../hooks/useStepsReducer';
const StepsContext = createContext(null);
export const StepsProvider = ({ children, initialStepsState }) => {
    const [stepsState, stepsDispatch] = useStepsReducer(initialStepsState, analyticsMiddleware);
    const value = useMemo(() => {
        return { stepsState, stepsDispatch };
    }, [stepsState, stepsDispatch]);
    return _jsx(StepsContext.Provider, Object.assign({ value: value }, { children: children }));
};
const useSteps = () => {
    const stepsContext = useContext(StepsContext);
    if (!stepsContext) {
        throw new Error('useSteps has to be used within <StepsProvider>');
    }
    return stepsContext;
};
export default useSteps;
//# sourceMappingURL=steps.context.js.map